<template>
  <div v-if="!src" id="plans-video-container" class="position-relative w-100 h-100">
    <div
      v-video-player:myVideoPlayer="options"
      :class="classes + (isProportional ? ' proportional' : '')"
      :playsinline="playsinline"
    ></div>
  </div>
  <div v-else class="embed-responsive embed-responsive-16by9">
    <iframe
      width="838"
      height="470"
      class="video-player-box overflow-hidden rounded embed-responsive-item"
      :src="src"
      frameborder="0"
    ></iframe>
  </div>
</template>

<script>
import Vue from 'vue';
if (process.browser) {
  const VueVideoPlayer = require('vue-video-player/dist/ssr');
  require('video.js/dist/video-js.css');
  Vue.use(VueVideoPlayer);
}
export default {
  name: 'Video',
  props: {
    path: {
      type: String,
      required: false,
      default: ''
    },
    options: {
      type: Object,
      required: false,
      default: function () {
        return {
          language: 'en',
          playbackRates: [1.0],
          sources: [
            {
              type: 'video/mp4',
              src: 'https://images.vexels.com/files/web/assets/meet-vexels.mp4'
            }
          ],
          poster: 'https://cdn.vexels.com/img/preview-video-vexels.jpg'
        };
      }
    },
    classes: {
      type: String,
      default: ''
    },
    playsinline: {
      type: Boolean,
      default: false
    },
    isProportional: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    src() {
      return this.path ? 'https://www.youtube.com/embed/' + this.path : '';
    }
  }
};
</script>

<style lang="scss">
#plans-video-container {
  .proportional .video-js {
    height: 0;
    padding-top: 56.25%;
    .vjs-big-play-button {
      position: absolute;
    }
  }
  .video-js {
    width: 100%;
    height: 700px;
    @media (max-width: 1700px) {
      height: 600px;
    }
    @media (max-width: 1500px) {
      height: 500px;
    }
    @include lg {
      height: 450px;
    }
    @include md {
      height: 400px;
    }
    @include sm {
      height: 350px;
    }
  }
  .video-js .vjs-big-play-button {
    left: 0;
    right: 0;
    margin: auto;
    top: calc(50% - 40px);
    background-color: #ff5a5f;
    border: none;
    height: 80px;
    width: 80px;
    border-radius: 200%;
    position: relative;
    @include md {
      height: 60px;
      width: 60px;
      top: calc(50% - 30px);
    }
  }
  .video-js:hover .vjs-big-play-button,
  .video-js .vjs-big-play-button:focus {
    background-color: #ff5a5f;
    border: none;
  }
  .video-js .vjs-big-play-button .vjs-icon-placeholder {
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
    top: 18px;
    font-size: 45px;
    transition: font-size 0.3s;
    @include md {
      top: 8px;
      font-size: 35px;
    }
  }
  .video-js .vjs-big-play-button:hover .vjs-icon-placeholder::before {
    font-size: 60px;
    @include md {
      font-size: 45px;
    }
  }
  .vjs-poster {
    background-size: cover;
    background-image: linear-gradient(45deg, rgba(15, 15, 15, 0.4), rgba(0, 0, 0, 0.4)),
      url('https://cdn.vexels.com/img/preview-video-vexels.jpg');
  }
}
</style>
